/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IChannelMessage extends IMessage {
	type: number;
	socketId: string;
	data: Buffer | ArrayBuffer;
}

/**
 * Default class for wrapping messages broadcasted by WebSocket Gateway on channels.
 */
export default class ChannelMessage extends Message {
	public static readonly DESCRIPTOR_NAME: string = 'ChannelMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			type: {
				type: 'uint32',
				id: 1
			},
			socketId: {
				type: 'string',
				id: 2
			},
			data: {
				type: 'bytes',
				id: 3
			}
		}
	};

	public constructor(
		public readonly type: number,
		public readonly socketId: string,
		public readonly data: Buffer | ArrayBuffer
	) {
		super();
	}

	public toJSON(): IChannelMessage {
		return {
			type: this.type,
			socketId: this.socketId,
			data: this.data
		};
	}

	public static fromJSON( data: IChannelMessage ): ChannelMessage {
		return new ChannelMessage( data.type, data.socketId, data.data );
	}
}
